import Chip from "@mui/material/Chip";
import React from "react";
import { useTheme } from "./ThemeContext";
import { Link } from "react-router-dom";

const TagsList = ({ tags, marginTop, large = false }) => {
  return (
    <span style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
      {tags.map((tag, index) => (
        <Chip
          size="small"
          label={tag.split(":").length > 1 ? tag.split(":")[1] : tag}
          clickable
          key={index}
          component={Link}
          to={tag.startsWith("c/") ? "/" + tag : "/s/" + tag}
          sx={{
            backgroundColor: "rgba(0,201,80,0.1)",
            border: "1px solid rgba(0,201,80,0.2)",
            color: "#05df72",
            fontSize: large ? { xs: "0.625rem", md: "0.75rem" } : "0.625rem",
            fontWeight: 500,
            height: large ? { xs: "20px", md: "26px" } : "20px",
            letterSpacing: "0.012em",
            borderRadius: "9999px",
            "& .MuiChip-label": { px: large ? { xs: "8px", md: "10px" } : "8px" },
            "&:hover": {
              backgroundColor: "rgba(0,201,80,0.2)",
              border: "1px solid rgba(0,201,80,0.4)",
            },
          }}
        />
      ))}
    </span>
  );
};
export default TagsList;
